// /var/www/website2024/dev.afaa.website/s-293-spatime-admin/src/utils/dateUtils.js

export const getSelectedDate = (selectedDate) => {
    return selectedDate || new Date().toISOString().slice(0, 10);
  };
  